export enum BubbleShapeEnum {
  SHAPE_1 = 'shape-1',
  SHAPE_2 = 'shape-2',
  SHAPE_3 = 'shape-3',
  SHAPE_4 = 'shape-4',
  SHAPE_5 = 'shape-5',
  SHAPE_6 = 'shape-6',
  SHAPE_7 = 'shape-7',
  SHAPE_8 = 'shape-8',
  SHAPE_9 = 'shape-9',
  SHAPE_10 = 'shape-10',
}

export const getBubbleShapeValues = () => Object.values(BubbleShapeEnum) as [string, ...string[]];
